import React, { useState, useRef, useEffect } from 'react';

interface OptimizedImageProps {
  src?: string;
  alt: string;
  className?: string;
  height?: string | number;
  width?: string | number;
  loading?: 'lazy' | 'eager';
  placeholder?: string;
  onLoad?: () => void;
  onError?: () => void;
}

const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  className = '',
  height,
  width,
  loading = 'lazy',
  placeholder = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjBmMGYwIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkxvYWRpbmcuLi48L3RleHQ+PC9zdmc+',
  onLoad,
  onError,
}) => {
  const [imageSrc, setImageSrc] = useState<string>(placeholder);
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (!src) return;

    const img = new Image();
    
    const handleLoad = () => {
      setImageSrc(src);
      setIsLoaded(true);
      onLoad?.();
    };

    const handleError = () => {
      setHasError(true);
      setImageSrc(placeholder);
      onError?.();
    };

    img.addEventListener('load', handleLoad);
    img.addEventListener('error', handleError);
    img.src = src;

    return () => {
      img.removeEventListener('load', handleLoad);
      img.removeEventListener('error', handleError);
    };
  }, [src, placeholder, onLoad, onError]);

  return (
    <div className="optimized-image-container">
      <img
        ref={imgRef}
        src={imageSrc}
        alt={alt}
        className={`optimized-image ${className} ${isLoaded ? 'loaded' : 'loading'} ${hasError ? 'error' : ''}`}
        height={height}
        width={width}
        loading={loading}
        style={{
          transition: 'opacity 0.3s ease-in-out',
          opacity: isLoaded ? 1 : 0.7,
        }}
      />
      
      {!isLoaded && !hasError && (
        <div className="image-loader">
          <div className="loader-spinner"></div>
        </div>
      )}
      
      {hasError && (
        <div className="image-error">
          <span>⚠️</span>
          <small>Image failed to load</small>
        </div>
      )}
      
      <style>{`
        .optimized-image-container {
          position: relative;
          display: inline-block;
          overflow: hidden;
          vertical-align: middle;
          width:100%;
        }
        
        .optimized-image {
          display: block;
          max-width: 100%;
          height: auto;
        }
        
        .optimized-image.loading {
          filter: blur(2px);
        }
        
        .optimized-image.error {
          opacity: 0.5;
        }
        
        .image-loader {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 1;
        }
        
        .loader-spinner {
          width: 20px;
          height: 20px;
          border: 2px solid #f3f3f3;
          border-top: 2px solid #007bff;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        
        .image-error {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
          color: #666;
          z-index: 1;
        }
        
        .image-error span {
          display: block;
          font-size: 1.5rem;
          margin-bottom: 0.25rem;
        }
        
        .image-error small {
          font-size: 0.8rem;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>


//  <div className="optimized-image-container">
//       <img
//         ref={imgRef}
//         src={imageSrc}
//         alt={alt}
//         className={`optimized-image ${className} ${isLoaded ? 'loaded' : 'loading'} ${hasError ? 'error' : ''}`}
//         height={height}
//         width={width}
//         loading={loading}
//         style={{
//           transition: 'opacity 0.3s ease-in-out',
//           opacity: isLoaded ? 1 : 0.7,
//         }}
//       />
      
//       {!isLoaded && !hasError && (
//         <div className="image-loader">
//           <div className="loader-spinner"></div>
//         </div>
//       )}
      
//       {hasError && (
//         <div className="image-error">
//           <span>⚠️</span>
//           <small>Image failed to load</small>
//         </div>
//       )}
      
//       <style>{`
//         .optimized-image-container {
//           position: relative;
//           display: inline-block;
//           overflow: hidden;
//           vertical-align: middle;
//         }
        
//         .optimized-image {
//           display: block;
//           max-width: 100%;
//           height: auto;
//         }
        
//         .optimized-image.loading {
//           filter: blur(2px);
//         }
        
//         .optimized-image.error {
//           opacity: 0.5;
//         }
        
//         .image-loader {
//           position: absolute;
//           top: 50%;
//           left: 50%;
//           transform: translate(-50%, -50%);
//           z-index: 1;
//         }
        
//         .loader-spinner {
//           width: 20px;
//           height: 20px;
//           border: 2px solid #f3f3f3;
//           border-top: 2px solid #007bff;
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//         }
        
//         .image-error {
//           position: absolute;
//           top: 50%;
//           left: 50%;
//           transform: translate(-50%, -50%);
//           text-align: center;
//           color: #666;
//           z-index: 1;
//         }
        
//         .image-error span {
//           display: block;
//           font-size: 1.5rem;
//           margin-bottom: 0.25rem;
//         }
        
//         .image-error small {
//           font-size: 0.8rem;
//         }
        
//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }
//       `}</style>
//     </div>
  );
};

export default OptimizedImage;
